import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login.vue'
import SignUp from './components/SignUp.vue'
import EmailVerification from './components/EmailVerification'
import SetPassword from './components/SetPassword'
import SendVerificationLinkForForgotPassword from './components/SendVerificationLinkForForgotPassword'
import ResetPassword from './components/ResetPassword'
// import VerifyOTP from './components/VerifyOTP'
import Success from './views/Success.vue'
import EmailVerificationForForgotPassword from './components/EmailVerificationForForgotPassword'
import EmailUpdateVerification from './components/EmailUpdateVerification'
import store from '@/store'
import document from './document/document.vue'
import taxCategoryUpdate from './components/TaxCategoryUpdate'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/redirectionVerification',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      beforeEnter: (to, from, next) => {
        const adminOnly = store.state.ApiculusEnv.adminOnly
        if (adminOnly === true) {
          next({ path: '/' })
        }
        next()
      }
    },
    {
      path: '/register/:param',
      name: 'emailVerification',
      component: EmailVerification
    },
    {
      path: '/process/:param',
      name: 'emailUpdateVerification',
      component: EmailUpdateVerification
    },
    {
      path: '/setPassword',
      name: 'SetPassword',
      component: SetPassword,
      // beforeEnter: (to, from, next) => {
      //   if (store.state.ApiculusEnv.mobileRequired && to.params.emailVerified && to.params.mobileVerified) {
      //     next()
      //   } else if (to.params.emailVerified) {
      //     next()
      //   } else {
      //     next({ path: '/signup' })
      //   }
      // }
    },
    {
      path: '/sendVerificationLink',
      name: 'SendVerificationLinkForForgotPassword',
      component: SendVerificationLinkForForgotPassword
    },
    {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/forgotPassword/:param',
      name: 'EmailVerificationForForgotPassword',
      component: EmailVerificationForForgotPassword
    },
    // {
    //   path: '/verifyOTP',
    //   name: 'VerifyOTP',
    //   component: VerifyOTP
    // },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/document',
      name: 'Documents',
      component: document
    },
    {
      path: '/taxCategoryUpdateVerification',
      name: 'taxCategoryUpdate',
      component: taxCategoryUpdate
    }
  ]
})
